/** Shared response-envelope helpers for target-plan and template modify/fetch endpoints. */

/** dietGet wraps axios as { data: apiBody }; a fetch-*-details body is usually { data: { ... } }. */
export const unwrapDietPayload = (res) => res?.data?.data ?? res?.data ?? res;

/** dietPost wraps axios as { data: { data: apiBody, status } }; API body is often { data: { meals } }. */
export const pickModifyList = (modifyRes, listKey) => {
  const postWrap = modifyRes?.data;
  const apiBody = postWrap?.data ?? postWrap;
  const nested = apiBody?.data?.[listKey];
  if (Array.isArray(nested)) return nested;
  if (Array.isArray(apiBody?.[listKey])) return apiBody[listKey];
  return [];
};
